import { render, staticRenderFns } from "./GovernanceStatusBadge.vue?vue&type=template&id=6d26afe8&scoped=true"
import script from "./GovernanceStatusBadge.vue?vue&type=script&lang=js"
export * from "./GovernanceStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./GovernanceStatusBadge.vue?vue&type=style&index=0&id=6d26afe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d26afe8",
  null
  
)

export default component.exports